import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Tenant } from 'planning-portal-library/src/lib/core/domain/models/tenant';
import { injectEnvironment } from 'planning-portal-library/src/lib/core/environments/environment.token';
import { TenantRepository } from 'planning-portal-library/src/lib/core/repositories';
import { Observable, catchError, map } from 'rxjs';
import { BaseResponse } from '../../shared/base.response';
import { TenantWebEntity } from './entities/tenant.web-entity';
import { TenantWebRepositoryMapper } from './entities/tenant.web-entity-mapper';

import { TenantApiUrls } from './tenant-api-urls';
import { FeatureConfiguration } from 'planning-portal-library/src/lib/core/domain/models/feature-configuration';
import { FeatureConfigurationWebRepositoryMapper } from './entities/feature-configurations.web-entity-mapper';
import { FeatureConfigurationWebEntity } from './entities/feature-configurations.web-entity';


@Injectable({ providedIn: 'root' })
export class TenantWebRepository extends TenantRepository {
  TenantMapper = new TenantWebRepositoryMapper();
 FeatureConfigurationMapper=new FeatureConfigurationWebRepositoryMapper();
  environment = injectEnvironment();

  constructor(private readonly http: HttpClient) {
    super();
  }

  getTenantById(request: string): Observable<Tenant> {
    return this.http
      .get<BaseResponse<TenantWebEntity>>(
        `${this.environment.url}${TenantApiUrls.GetTenantbyId}`,
        {
          params: {
            id: request,
          },
        }
      )
      .pipe(
        map((response: BaseResponse<TenantWebEntity>) => response.result!),
        catchError((err) => {
          throw err;
        })
      )
      .pipe(map(this.TenantMapper.mapFrom));
  }


   getFeatureConfigurations(): Observable<FeatureConfiguration[]> {
      return this.http
        .get<BaseResponse<FeatureConfigurationWebEntity[]>>(
          `${this.environment.url}${TenantApiUrls.GetFeatureConfigurations}`
        )
        .pipe(
          map((data: BaseResponse<FeatureConfigurationWebEntity[]>) => {
            if (!Array.isArray(data.result)) {
              return [];
            }
            return data.result;
          }),
          catchError((err) => {
            throw err;
          })
        )
        .pipe(map((items) => items.map(this.FeatureConfigurationMapper.mapFrom)));
    }    
}
